import { getInitializeViewTestSubjectStore } from '@doltech/modules/lib/view-test-subject/model/view-test-subject.hook';
import { ViewTestSubjectStore } from '@doltech/modules/lib/view-test-subject/model/view-test-subject.store';
import { ViewVocabLayout } from '@doltech/modules/lib/view-vocab/ViewVocabLayout';
import { DynamicPageProps } from '@doltech/routeDefinition';
import { SharedFooter } from '@doltech/ui/lib/figma/Layout/Landing/Footer/SharedFooter';
import { withDolPremiumStore } from '@doltech/ui/lib/hooks/dolPremium/withDolPremium';
import { useCreateStore, useProvider } from 'mobx-store-provider';
import * as React from 'react';
import styled from 'styled-components';
import { compose } from '@doltech/utils/lib/compose';

const Main = styled.div.withConfig({
  componentId: 'ViewVocabTemplatePage_Main',
} as any)`
  padding-bottom: 60px;
`;

interface ViewTestQuestionTemplatePageProps extends DynamicPageProps {}

const ViewVocabTemplatePage = (props: ViewTestQuestionTemplatePageProps) => {
  const { data } = props;
  const viewTestSubjectCreateStore = useCreateStore(
    ViewTestSubjectStore,
    getInitializeViewTestSubjectStore(data, data.testType)
  );

  const ViewTestSubjectStoreProvider = useProvider(ViewTestSubjectStore);

  return (
    <ViewTestSubjectStoreProvider value={viewTestSubjectCreateStore}>
      <Main>
        <ViewVocabLayout {...props} />
      </Main>
      <SharedFooter />
    </ViewTestSubjectStoreProvider>
  );
};

export default compose(withDolPremiumStore({}))(ViewVocabTemplatePage);
